// extracted by css-extract-rspack-plugin
export default {"modalManagePackageLabels":"fikWZD0vKojd4Wsd","link":"A5yun5aHQyg3fPjn","helpText":"U5J_FlTZPA8q2FG1","removeButton":"aw6gWd2Tm4PF5xSr","removeText":"OPj7uUAzd8wkHw4W"};